// =============================================================================
// TODO: REMOVE AFTER #27 DEBUG  (issue #5 Phase R: drag-touch-fix-v2)
// 切り分け終了後にこのモジュールと各計装呼出 (`dragDebug(...)`)
// および <DragDebugOverlay /> を一括削除する。 grep "DRAG_DEBUG_TAG" で検出可能。
// FingeringEditorPage から issue #17 Phase 2 で抽出。
// =============================================================================

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const DRAG_DEBUG_TAG = '[drag-debug-v2]';
export const DRAG_DEBUG_MAX_LINES = 12;
export type DragDebugEntry = { text: string; ts: number; highlight?: boolean };

export const dragDebugLog: DragDebugEntry[] = [];
export const dragDebugListeners = new Set<() => void>();

export function dragDebug(text: string, opts: { highlight?: boolean } = {}): void {
  // 計装は重い処理を避けるため module-level で append。 React state は listener 経由で更新。
  const ts = Date.now();
  dragDebugLog.push({ text, ts, highlight: opts.highlight });
  while (dragDebugLog.length > DRAG_DEBUG_MAX_LINES) dragDebugLog.shift();
  dragDebugListeners.forEach((fn) => fn());
}

export function isDragDebugEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('debug') === '1') return true;
    return window.localStorage.getItem('omakase-unshi:debug:drag') === '1';
  } catch {
    return false;
  }
}

// TODO: REMOVE AFTER #5 DEBUG — issue #28 Phase 2-B 観測強化用 throttle helper
// pointermove / clientToSvg 等の高頻度計装で overlay 行数を圧迫しないため N 回ごとに 1 回だけ出力。
// counter は key ごとに分離 (例: 'move' / 'rect' )。
const dragDebugThrottleCounters = new Map<string, number>();
export function dragDebugThrottled(key: string, every: number, text: string,
                                   opts: { highlight?: boolean } = {}): void {
  const next = (dragDebugThrottleCounters.get(key) ?? 0) + 1;
  dragDebugThrottleCounters.set(key, next);
  if (next % every !== 1) return;
  dragDebug(text, opts);
}

// テスト等で counter をリセットするため
export function resetDragDebugThrottle(): void {
  dragDebugThrottleCounters.clear();
}
